import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticateWithRedirectCallback } from '@clerk/react';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import FeedbackPage from './pages/FeedbackPage';
import BlockedPage from './pages/BlockedPage';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import HelpPage from './pages/HelpPage';
import VerifiedPage from './pages/VerifiedPage';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function App() {
  return (
    <Router>
      <ErrorBoundary>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/app" element={<Dashboard />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/blocked" element={<BlockedPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/verified" element={<VerifiedPage />} />
          {/* Completes the Google OAuth redirect, then continues to /verified */}
          <Route
            path="/sso-callback"
            element={<AuthenticateWithRedirectCallback signInForceRedirectUrl="/verified" signUpForceRedirectUrl="/verified" />}
          />
          {/* Redirect root to /app which handles auth redirection to /login */}
          <Route path="/" element={<Navigate to="/app" replace />} />
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
}

export default App;